import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["error", "label", "name", "onChange", "value"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.function.name.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useCallback, useMemo } from 'react';
import { InlineDatePicker } from '@applyboard/ui-components';
import moment from 'moment';
import { ErrorWrapper } from "./style";

// eslint-disable-line @typescript-eslint/no-explicit-any
// eslint-disable-line @typescript-eslint/no-explicit-any

/**
 * @deprecated use the InlineDatePicker instead
 */
var CalendarInput = function CalendarInput(_ref) {
  var error = _ref.error,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleChange = useCallback(function (e) {
    return onChange({
      target: {
        name: name,
        value: e
      }
    });
  }, [name, onChange]);
  var selectedValue = useMemo(function () {
    return typeof value === 'string' && value.length > 0 ? moment(value) : null;
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    className: "date-picker"
  }, /*#__PURE__*/React.createElement(InlineDatePicker, _extends({
    label: label,
    fullWidth: true,
    inputVariant: "outlined",
    selectedDate: selectedValue,
    onChange: handleChange,
    name: name
  }, props)), error && /*#__PURE__*/React.createElement(ErrorWrapper, null, error));
};
export default CalendarInput;